export default __webpack_public_path__ + "assets/images/4d6c7db386b255950498102e1c8ba0ad.png";